import React, { useState } from 'react';
import './Login.css';
import { Link, useNavigate } from "react-router-dom";

import Header from '../../../components/common/Header/header';
import { useAuth } from '../../../contexts/AuthContext';
import ErrorDisplay from '../../../components/common/Error/Error';
import Toast from '../../../components/common/Toast/Toast';

function Login() {
    const { handleLogin, error, loading } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [toast, setToast] = useState(null);
    const navigate = useNavigate();

    const onSubmit = async (e) => {
        e.preventDefault();
        await handleLogin(email, password);
        setToast({ message: 'Connexion réussie ! Bienvenue !', type: 'success' });
        setTimeout(() => {
            navigate('/'); // Redirect to home or dashboard after login
        }, 1500);
    };

    return (
        <div className="login-container">
            <div className="login-header">
                <Header />
            </div>

            <div className='login-content'>
                <form onSubmit={onSubmit}>
                    <div className="form-group">
                        <label htmlFor="email">E-mail:</label><br />
                        <input
                            type="email"
                            id="email"
                            name="email"
                            className="form-input"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">Mot de passe:</label><br />
                        <input
                            type="password"
                            id="password"
                            name="password"
                            className="form-input"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            required
                        />
                    </div>

                    {error && <ErrorDisplay errorData={error} />}

                    <button type="submit" className="form-button" disabled={loading}>
                        {loading ? 'Connexion...' : 'Se connecter'}
                    </button>
                </form>
            </div>

            <footer>
                <Link to="/legal-mention">Mentions légales</Link>
                
            </footer>

            {toast && (
                <Toast 
                    message={toast.message} 
                    type={toast.type} 
                    onClose={() => setToast(null)} 
                />
            )}
        </div>
    );
}

export default Login;